import { render, staticRenderFns } from "./CustomerActivityTicket.vue?vue&type=template&id=2f99fcb8&"
import script from "./CustomerActivityTicket.vue?vue&type=script&lang=js&"
export * from "./CustomerActivityTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports